import React from 'react';
import Header from '../../components/Header/Header';
import LoginForm from '../../components/LoginForm/LoginForm';
import ImageSection from '../../components/ImageSection/ImageSection';
import Footer from '../../components/Footer/Footer';
import './Login.css';

const Login: React.FC = () => (
  <div className="app-container">
    <Header />
    <div className="content-container">
      <LoginForm />
      <ImageSection />
    </div>
    <Footer />
  </div>
);

export default Login;
